<template>
  <div>
    <gc-popup
      :popup-visible="gcPopupDataGridVisible"
      :popup-title="gcPopupDataGridConfig.title"
      :popup-titles="gcPopupDataGridConfig.titles"
      :back-button-function="popUpBackButtonClick"
      :popupHeight="660"
      v-if="gcPopupDataGridConfig"
      :saveButtonConfig="gcPopupDataGridConfig.save"
      :backButtonConfig="gcPopupDataGridConfig.back"
      :data-model="
        gcPopupDataGridConfig.dataModel
          ? gcPopupDataGridConfig.dataModel
          : transactionData
      "
      :popupWidth="gcPopupDataGridConfig.popupWidth"
      :popUpContent="'gc-data-grid'"
    >
      <GcDataGrid
        :grouping="true"
        :export="true"
        :summary="true"
        :dataSourceConfig="
          gcPopupDataGridConfig.gridData.gridOptions.dataSource
        "
        :columns="gcPopupDataGridConfig.gridData.columns"
        :valueChangeListners="
          gcPopupDataGridConfig.gridData.valueChangedEventListners
        "
        :gridToolbar="gcPopupDataGridConfig.gridData.toolbar"
        :padColumn="true"
        :id="'gcPopupDataGrid'"
        v-if="gcPopupDataGridConfig.gridData"
        ref="gcPopupDataGrid"
        :isLocalDataSource="
          gcPopupDataGridConfig.gridData.gridOptions.dataSource.localDataList
        "
        :isEditableGrid="true"
        :showFooter="gcPopupDataGridConfig.gridData.gridOptions.footerEnabled"
        :gridOptions="gcPopupDataGridConfig.gridData.gridOptions"
        :dataModel="transactionData"
        :elementAttrClass="'gc-popup-data-grid'"
        :gridHeightOverWrite="500"
      />
    </gc-popup>
  </div>
</template>

<script>
export default {
  props: {
    gcPopupDataGridVisible: {
      type: Boolean,
      default: false,
    },
    gcPopupDataGridConfig: {
      type: Object,
      default: () => {},
    },
    transactionData: {
      type: Object,
      default: () => {},
    },
    popUpBackButtonClick: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  async created() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss">
</style>
